import React from 'react';
import { Box, useTheme } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const HousePhotos = () => {
    const theme = useTheme();

    const photos = [
        { src: '/images/house1.jpg', alt: 'House Photo 1' },
        { src: '/images/house2.jpg', alt: 'House Photo 2' },
        { src: '/images/house3.jpg', alt: 'House Photo 3' },
        { src: '/images/address.jpg', alt: 'House Address' },
        { src: '/images/beds.jpg', alt: 'beds' },
        { src: '/images/computers.jpg', alt: '2 computers' },
        { src: '/images/livingRoom.jpg', alt: 'living room' },
        { src: '/images/piano.jpg', alt: 'girld learning piano' },
    ];
    const sliderParams = {
        slidesPerView: 1, // Show one slide at a time
        spaceBetween: 0, // No space between slides
        loop: true, // Optional: loop the slides
        pagination: {
            clickable: true, // Make pagination dots clickable
        },
        navigation: true, // Show navigation buttons
        modules: [Navigation, Pagination], // Include the modules
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            // when window width is >= 640px
            640: {
                slidesPerView: 1,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: 1,
            },
            1024: {
                slidesPerView: 1,
            },
        }
    };

    return (
        <Box>
            <Swiper {...sliderParams}>
                {photos.map((photo, index) => (
                    <SwiperSlide key={index}>
                        <img
                            src={photo.src}
                            alt={photo.alt}
                            loading="lazy"
                            style={{
                                width: '100%',
                                height: 'auto', // Maintain aspect ratio
                                objectFit: 'cover',
                                borderRadius: theme.shape.borderRadius,
                            }}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </Box>
    );
};

export default HousePhotos;